import React, { ErrorInfo } from "react";

type ErrorBoundaryState = {
  hasError: boolean;
};

export class ErrorBoundary extends React.Component<{}, ErrorBoundaryState, {}> {
  constructor(props: {}) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
    console.log("ErrorBoundary::Error", error);
    console.log("ErrorBoundary::ErrorInfo", errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Custom fallback UI
      return (
        <div className="m-4 text-center d-flex flex-column align-items-center w-100">
          <h1>Sorry, Something went wrong!</h1>
          <a className="btn btn-warning" href="/" role="button">
            Reload
          </a>
        </div>
      );
    }

    return this.props.children;
  }
}
